/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compliance_Link_AndInputs */

const tr_pricing_compliance_link_and = /** @type {(inputs: Pricing_Compliance_Link_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ve`)
};

const en_pricing_compliance_link_and = /** @type {(inputs: Pricing_Compliance_Link_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and`)
};

const de_pricing_compliance_link_and = /** @type {(inputs: Pricing_Compliance_Link_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`und`)
};

const ru_pricing_compliance_link_and = /** @type {(inputs: Pricing_Compliance_Link_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`и`)
};

/**
* | output |
* | --- |
* | "and" |
*
* @param {Pricing_Compliance_Link_AndInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compliance_link_and = /** @type {((inputs?: Pricing_Compliance_Link_AndInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compliance_Link_AndInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_compliance_link_and(inputs)
	if (locale === "de") return de_pricing_compliance_link_and(inputs)
	if (locale === "ru") return ru_pricing_compliance_link_and(inputs)
	return tr_pricing_compliance_link_and(inputs)
});